<template>
  <div class="col-sm-12">
    <div
      class="card transaction-card"
      :class="{ 'no-recent-payments': !loading && !hasAnyPayment }"
    >
      <div class="card-header card-no-border">
        <div class="header-top">
          <h5>Invoice Payments (MTD)</h5>

          <!-- <div class="d-flex align-items-center"> -->
          <div class="payment-header-actions">
            <!-- View Invoices on the Map Button -->
            <button
              class="btn btn-light map-btn me-2"
              @click="showMapPopup = true"
              title="View on Map"
            >
              <i class="fas fa-map-marker-alt"></i>
              <span class="tooltip-text">View on Map</span>
            </button>

            <!-- Map Modal Component -->
            <InvoiceMapModal
              v-if="showMapPopup"
              :profileId="profileId"
              @close-modal="closeModal"
            />

            <!-- Vue Controlled Tabs -->
            <ul class="nav nav-tabs custom-tab" role="tablist">
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link text-primary"
                  :class="{ active: activePaymentTab === 'all' }"
                  type="button"
                  @click="activePaymentTab = 'all'"
                >
                  All
                </button>
              </li>

              <li class="nav-item" role="presentation">
                <button
                  class="nav-link text-success"
                  :class="{ active: activePaymentTab === 'collected' }"
                  type="button"
                  @click="activePaymentTab = 'collected'"
                >
                  Collected
                </button>
              </li>

              <li class="nav-item" role="presentation">
                <button
                  class="nav-link text-danger"
                  :class="{ active: activePaymentTab === 'due' }"
                  type="button"
                  @click="activePaymentTab = 'due'"
                >
                  Due
                </button>
              </li>
            </ul>
            <router-link
              v-if="!loading && hasAnyPayment"
              class="btn btn-sm mtd-view-details-btn"
              to="/invoice"
            >
              View Details
            </router-link>
          </div>
        </div>
      </div>

      <div class="card-body pt-0">
        <!-- Loader -->
        <div v-if="loading" class="payment-loading-state">
          <div class="spinner-border text-primary" role="status"></div>
          <span>Loading invoice payments...</span>
        </div>

        <template v-else>
          <!-- Total Cards -->
          <div class="invoice-mtd-summary-grid">
            <div class="card summary-card all-invoices text-white">
              <div class="card-body">
                <h6 class="text-primary">Total Invoices</h6>
                <h3 class="text-dark">{{ totalCards[0].amount }}</h3>
              </div>
            </div>

            <div class="card summary-card collected-payments text-white">
              <div class="card-body">
                <h6 class="text-success">Total Collections</h6>
                <h3 class="text-dark">{{ totalCards[1].amount }}</h3>
              </div>
            </div>

            <div class="card summary-card due-payments text-white">
              <div class="card-body">
                <h6 class="text-danger">Total Due Payments</h6>
                <h3 class="text-dark">{{ totalCards[2].amount }}</h3>
              </div>
            </div>
          </div>

          <!-- Payment Panel - No Bootstrap tab-pane -->
          <div class="payment-panel">
            <div
              v-if="activePaymentTabData.invoices.length"
              class="recent-payment-list"
            >
              <div
                v-for="item in activePaymentTabData.invoices"
                :key="item.id"
                class="invoice-row-card"
              >
                <div class="invoice-avatar">
                  {{ getInitials(item.name) }}
                </div>

                <div class="invoice-main">
                  <div class="invoice-title-row">
                    <div>
                      <h6>{{ item.name }}</h6>
                      <p>{{ item.number }}</p>
                    </div>

                    <span
                      class="invoice-status"
                      :class="activePaymentTabData.badgeClass"
                    >
                      {{ activePaymentTabData.badgeLabel }}
                    </span>
                  </div>

                  <div class="invoice-meta-grid">
                    <div
                      class="invoice-meta-box amount"
                      :class="activePaymentTabData.amountClass"
                    >
                      <span class="meta-label">Amount</span>
                      <span class="meta-value">
                        {{ item.amount }}
                      </span>
                    </div>

                    <div class="invoice-meta-box date">
                      <span class="meta-label">Date</span>
                      <span class="meta-value">
                        {{ item.date }}
                      </span>
                    </div>

                    <div class="invoice-meta-box address">
                      <span class="meta-label">Address</span>
                      <span class="meta-value">
                        {{ item.address || "No address available" }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="recent-empty-state">
              <div
                class="empty-icon"
                :class="activePaymentTabData.emptyIconClass"
              >
                <i :class="activePaymentTabData.emptyIcon"></i>
              </div>

              <h6>{{ activePaymentTabData.emptyTitle }}</h6>
              <p>{{ activePaymentTabData.emptyText }}</p>
            </div>
          </div>

          <!-- <router-link
            v-if="hasAnyPayment"
            class="text-dark see-more"
            to="/invoice"
          >
            See More
          </router-link> -->
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import InvoiceMapModal from "@/pages/Modal/maps/invoiceMapModal.vue";
import { invoicePaymentData } from "@/services/dataService";

export default {
  components: {
    InvoiceMapModal,
  },

  data() {
    return {
      token: localStorage.getItem("token_set"),
      profileId: localStorage.getItem("profile_id"),

      activePaymentTab: "all",

      allInvoices: [],
      collectedInvoices: [],
      dueInvoices: [],

      totalCards: [
        {
          title: "Total Invoices (LKR)",
          amount: "0.00",
        },
        {
          title: "Total Collection (LKR)",
          amount: "0.00",
        },
        {
          title: "Total Due Payments (LKR)",
          amount: "0.00",
        },
      ],

      loading: true,
      showMapPopup: false,
    };
  },

  computed: {
    hasAnyPayment() {
      return (
        this.allInvoices.length > 0 ||
        this.collectedInvoices.length > 0 ||
        this.dueInvoices.length > 0
      );
    },

    paymentTabs() {
      return [
        {
          id: "all",
          invoices: this.allInvoices.slice(0, 5),
          amountClass: "all",
          badgeClass: "all-badge",
          badgeLabel: "Invoice",
          emptyIconClass: "",
          emptyIcon: "fa fa-receipt",
          emptyTitle: "No recent payments",
          emptyText:
            "Recent payment records are not available for this month. Summary totals are still shown above.",
        },
        {
          id: "collected",
          invoices: this.collectedInvoices.slice(0, 5),
          amountClass: "collected",
          badgeClass: "collected-badge",
          badgeLabel: "Collected",
          emptyIconClass: "success",
          emptyIcon: "fa fa-check-circle",
          emptyTitle: "No collected payments",
          emptyText:
            "There are no collected payment records available for this month.",
        },
        {
          id: "due",
          invoices: this.dueInvoices.slice(0, 5),
          amountClass: "due",
          badgeClass: "due-badge",
          badgeLabel: "Due",
          emptyIconClass: "danger",
          emptyIcon: "fa fa-clock",
          emptyTitle: "No due payments",
          emptyText:
            "There are no due payment records available for this month.",
        },
      ];
    },

    activePaymentTabData() {
      return (
        this.paymentTabs.find((tab) => tab.id === this.activePaymentTab) ||
        this.paymentTabs[0]
      );
    },
  },

  watch: {
    showMapPopup(newVal) {
      document.body.style.overflow = newVal ? "hidden" : "";
    },
  },

  created() {
    this.fetchPaymentData();
  },

  beforeUnmount() {
    document.body.style.overflow = "";
  },

  methods: {
    closeModal() {
      this.showMapPopup = false;
    },

    getInitials(name) {
      if (!name) return "NA";

      const words = String(name).trim().split(/\s+/);
      const first = words[0]?.[0] || "";
      const second = words.length > 1 ? words[1]?.[0] || "" : "";

      return `${first}${second}`.toUpperCase() || "NA";
    },

    parseAmount(amount) {
      return (
        Number(
          String(amount || "")
            .replace(/Rs\.|\s|,/g, "")
            .trim(),
        ) || 0
      );
    },

    formatAmount(value) {
      return Number(value || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    normalizeInvoiceList(list) {
      if (!Array.isArray(list)) return [];

      return list.map((item, index) => ({
        id: item.id || item.number || `${item.name}-${item.date}-${index}`,
        name: item.name || "Unknown Dealer",
        date: item.date || "-",
        number: item.number || "-",
        address: item.address || "",
        amount: item.amount || "Rs. 0.00",
        coords: item.coords || null,
      }));
    },

    async fetchPaymentData() {
      try {
        this.loading = true;

        const response = await invoicePaymentData(this.profileId, this.token);

        /*
          Supports both structures:
          response.data.all
          response.data.data.all
        */
        const payload = response?.data?.data || response?.data || {};

        this.allInvoices = this.normalizeInvoiceList(payload.all);
        this.collectedInvoices = this.normalizeInvoiceList(payload.collected);
        this.dueInvoices = this.normalizeInvoiceList(payload.due);

        const sum = (arr) =>
          arr.reduce((total, item) => total + this.parseAmount(item.amount), 0);

        const totals = payload.totals || {};

        const totalInvoices =
          Number(totals.total_invoice) || sum(this.allInvoices);
        const totalCollected =
          Number(totals.total_collected) || sum(this.collectedInvoices);
        const totalDue = Number(totals.total_due) || sum(this.dueInvoices);

        this.totalCards = [
          {
            title: "Total Invoices (LKR)",
            amount: this.formatAmount(totalInvoices),
          },
          {
            title: "Total Collection (LKR)",
            amount: this.formatAmount(totalCollected),
          },
          {
            title: "Total Due Payments (LKR)",
            amount: this.formatAmount(totalDue),
          },
        ];
      } catch (error) {
        console.error("Error fetching payment data:", error);

        this.allInvoices = [];
        this.collectedInvoices = [];
        this.dueInvoices = [];

        this.totalCards = [
          { title: "Total Invoices (LKR)", amount: "0.00" },
          { title: "Total Collection (LKR)", amount: "0.00" },
          { title: "Total Due Payments (LKR)", amount: "0.00" },
        ];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.transaction-card {
  height: 100%;
  border-radius: 16px;
  overflow: hidden;
}

.header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.header-top h5 {
  margin: 0;
  font-size: 14px;
  font-weight: 850;
  color: #0f172a;
}

/* Summary cards */
.all-invoices {
  background-color: #e0ecff;
  border: 1px solid #d5e6ff;
}

.collected-payments {
  background-color: #e5f4e9;
  border: 1px solid #d9efdf;
}

.due-payments {
  background-color: #fbe9eb;
  border: 1px solid #f8d7dc;
}

.transaction-card .summary-card {
  height: 74px !important;
  min-height: 74px !important;
  max-height: 74px !important;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.035);
}

.transaction-card .summary-card .card-body {
  height: 100%;
  padding: 12px 16px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.transaction-card .summary-card h6 {
  margin: 0 0 8px;
  font-size: 11.5px;
  font-weight: 800;
  letter-spacing: 0.04em;
}

.transaction-card .summary-card h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 850;
  line-height: 1.1;
}

/* Map button */
.map-btn {
  position: relative;
  border-radius: 10px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid #e2e8f0;
}

.tooltip-text {
  visibility: hidden;
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 6px 10px;
  border-radius: 4px;
  position: absolute;
  bottom: 42px;
  right: 50%;
  transform: translateX(50%);
  white-space: nowrap;
  font-size: 12px;
  z-index: 1001;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.map-btn:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}

/* Tabs */
.custom-tab {
  border-bottom: none;
  background: #f8fafc;
  border-radius: 12px;
  padding: 4px;
}

.custom-tab .nav-link {
  border: none;
  border-radius: 9px;
  font-weight: 800;
  font-size: 12px;
  padding: 7px 12px;
}

.custom-tab .nav-link.active {
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
}

/* Loader */
.payment-loading-state {
  min-height: 230px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

/* Payment panel */
.payment-panel {
  display: block !important;
  min-height: 170px;
  margin-top: 2px;
}

.recent-payment-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 370px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
  scroll-behavior: smooth;
  overscroll-behavior: contain;
  scrollbar-width: thin;
  scrollbar-color: rgba(100, 116, 139, 0.72) transparent;
}

.recent-payment-list::-webkit-scrollbar {
  width: 6px;
}

.recent-payment-list::-webkit-scrollbar-track {
  background: transparent;
}

.recent-payment-list::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #94a3b8 0%, #64748b 100%);
  border-radius: 999px;
  border: 1px solid #ffffff;
}

.recent-payment-list::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #64748b 0%, #475569 100%);
}

.recent-payment-card {
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr);
  gap: 9px;
  align-items: flex-start;
  padding: 9px 10px;
  border: 1px solid #e8edf4;
  border-radius: 13px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  box-shadow: 0 5px 14px rgba(15, 23, 42, 0.035);
  transition: all 0.2s ease;
}

.recent-payment-card:hover {
  transform: translateY(-1px);
  border-color: #dbe3ef;
  box-shadow: 0 9px 20px rgba(15, 23, 42, 0.065);
}

.payment-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #198754 0%, #087f45 100%);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 850;
  text-transform: uppercase;
  box-shadow: 0 7px 16px rgba(25, 135, 84, 0.18);
}

.payment-main {
  min-width: 0;
}

.payment-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
}

.payment-title-content {
  min-width: 0;
}

.payment-title-content h6 {
  margin: 0;
  color: #111827;
  font-size: 12.5px;
  font-weight: 850;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.payment-title-content p {
  margin: 2px 0 0;
  color: #64748b;
  font-size: 11.5px;
  font-weight: 700;
  line-height: 1.2;
  overflow-wrap: anywhere;
}

.payment-date {
  flex-shrink: 0;
  color: #475569;
  font-size: 10.5px;
  font-weight: 800;
  white-space: nowrap;
}

.payment-bottom-row {
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.payment-address {
  min-width: 0;
  color: #94a3b8;
  font-size: 10.5px;
  font-weight: 650;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.payment-amount {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 900;
  white-space: nowrap;
}

.payment-amount.all {
  color: #0d6efd;
}

.payment-amount.collected {
  color: #087f45;
}

.payment-amount.due {
  color: #dc2626;
}

/* Empty state */
.recent-empty-state {
  min-height: 155px;
  border: 1px dashed #dbe3ef;
  border-radius: 14px;
  background: radial-gradient(
      circle at top,
      rgba(25, 135, 84, 0.08),
      transparent 34%
    ),
    linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  text-align: center;
  padding: 16px;
}

.empty-icon {
  width: 40px;
  height: 40px;
  border-radius: 14px;
  background: #ecfdf5;
  color: #198754;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  box-shadow: 0 8px 18px rgba(25, 135, 84, 0.12);
}

.empty-icon.success {
  background: #ecfdf5;
  color: #087f45;
}

.empty-icon.danger {
  background: #fff1f2;
  color: #dc2626;
}

.recent-empty-state h6 {
  margin: 4px 0 0;
  font-size: 13px;
  font-weight: 850;
  color: #0f172a;
}

.recent-empty-state p {
  margin: 0;
  max-width: 340px;
  font-size: 11.5px;
  font-weight: 550;
  color: #64748b;
  line-height: 1.4;
}

/* See more */
.see-more {
  display: inline-flex;
  margin-top: 8px;
  font-size: 12px;
  font-weight: 850;
  text-decoration: none;
}

.see-more:hover {
  cursor: pointer;
  font-weight: 900;
}

/* Mobile */
@media (max-width: 768px) {
  .transaction-card .summary-card {
    height: 62px !important;
    min-height: 62px !important;
    max-height: 62px !important;
  }

  .transaction-card .summary-card h6 {
    font-size: 10.5px;
    margin-bottom: 5px;
  }

  .transaction-card .summary-card h3 {
    font-size: 15px;
  }

  .recent-empty-state {
    min-height: 165px;
  }

  .payment-bottom-row {
    flex-direction: column;
    align-items: flex-start;
  }
}

.transaction-card > .card-body {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* Replace Bootstrap row behavior with compact grid */
.invoice-mtd-summary-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 10px;
  flex: 0 0 auto !important;
  height: auto !important;
  min-height: 0 !important;
  max-height: none !important;
  align-items: start !important;
}

.invoice-mtd-summary-grid .summary-card {
  width: 100%;
  height: 74px !important;
  min-height: 74px !important;
  max-height: 74px !important;
  align-self: start !important;
  margin: 0 !important;
}

.invoice-mtd-summary-grid .summary-card .card-body {
  height: 74px !important;
  min-height: 74px !important;
  max-height: 74px !important;
  padding: 12px 16px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* Force payment cards area to start immediately under summary cards */
.payment-panel {
  position: relative;
  z-index: 2;
  display: block !important;
  flex: 0 0 auto !important;
  min-height: 170px;
  margin-top: 0 !important;
}

/* Stop any old Bootstrap row/col stretch from affecting this card */
.transaction-card .summary-row,
.transaction-card .summary-row > div {
  height: auto !important;
  min-height: 0 !important;
  max-height: none !important;
  flex: 0 0 auto !important;
}

/* Mobile */
@media (max-width: 768px) {
  .invoice-mtd-summary-grid {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .invoice-mtd-summary-grid .summary-card,
  .invoice-mtd-summary-grid .summary-card .card-body {
    height: 62px !important;
    min-height: 62px !important;
    max-height: 62px !important;
  }
}

/* Same invoice card styling as INVOICES AND PAYMENTS */
.payment-panel {
  position: relative;
  z-index: 2;
  display: block !important;
  flex: 0 0 auto !important;
  min-height: 170px;
  margin-top: 0 !important;
}

.recent-payment-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 335px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
  scroll-behavior: smooth;
  overscroll-behavior: contain;
  scrollbar-width: thin;
  scrollbar-color: rgba(100, 116, 139, 0.72) transparent;
}

.recent-payment-list::-webkit-scrollbar {
  width: 6px;
}

.recent-payment-list::-webkit-scrollbar-track {
  background: transparent;
}

.recent-payment-list::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #94a3b8 0%, #64748b 100%);
  border-radius: 999px;
  border: 1px solid #ffffff;
}

.recent-payment-list::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #64748b 0%, #475569 100%);
}

.invoice-row-card {
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr);
  gap: 9px;
  align-items: flex-start;
  padding: 9px 10px;
  border: 1px solid #e8edf4;
  border-radius: 13px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  box-shadow: 0 5px 14px rgba(15, 23, 42, 0.035);
  transition: all 0.2s ease;
}

.invoice-row-card:hover {
  transform: translateY(-1px);
  border-color: #dbe3ef;
  box-shadow: 0 9px 20px rgba(15, 23, 42, 0.065);
}

.invoice-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #198754 0%, #087f45 100%);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 850;
  text-transform: uppercase;
  box-shadow: 0 7px 16px rgba(25, 135, 84, 0.18);
}

.invoice-main {
  min-width: 0;
}

.invoice-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
}

.invoice-title-row h6 {
  margin: 0;
  color: #111827;
  font-size: 12.5px;
  font-weight: 850;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.invoice-title-row p {
  margin: 2px 0 0;
  color: #64748b;
  font-size: 11.5px;
  font-weight: 700;
  line-height: 1.2;
  overflow-wrap: anywhere;
}

.invoice-status {
  flex-shrink: 0;
  height: 21px;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 800;
  line-height: 1.2;
}

.all-badge {
  background: #eff6ff;
  color: #0d6efd;
  border: 1px solid #bfdbfe;
}

.collected-badge {
  background: #ecfdf5;
  color: #087f45;
  border: 1px solid #bbf7d0;
}

.due-badge {
  background: #fff1f2;
  color: #dc2626;
  border: 1px solid #fecdd3;
}

.invoice-meta-grid {
  margin-top: 8px;
  display: grid;
  grid-template-columns: 1fr 0.8fr 1.4fr;
  gap: 7px;
}

.invoice-meta-box {
  min-width: 0;
  padding: 7px 8px;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
}

.invoice-meta-box.amount.all {
  background: #eff6ff;
  border-color: #dbeafe;
}

.invoice-meta-box.amount.collected {
  background: #f0fdf4;
  border-color: #dcfce7;
}

.invoice-meta-box.amount.due {
  background: #fff7f7;
  border-color: #ffe1e1;
}

.invoice-meta-box.date,
.invoice-meta-box.address {
  background: #f8fafc;
}

.meta-label {
  display: block;
  color: #94a3b8;
  font-size: 10px;
  font-weight: 750;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  line-height: 1.2;
}

.meta-value {
  display: block;
  margin-top: 3px;
  color: #0f172a;
  font-size: 11.5px;
  font-weight: 850;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.invoice-meta-box.amount.all .meta-value {
  color: #0d6efd;
}

.invoice-meta-box.amount.collected .meta-value {
  color: #087f45;
}

.invoice-meta-box.amount.due .meta-value {
  color: #dc2626;
}

.invoice-meta-box.address .meta-value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Mobile */
@media (max-width: 768px) {
  .invoice-meta-grid {
    grid-template-columns: 1fr;
  }

  .invoice-title-row {
    flex-direction: column;
    gap: 6px;
  }

  .invoice-status {
    align-self: flex-start;
  }
}

.payment-header-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
}

.mtd-view-details-btn {
  height: 34px;
  min-width: 98px;
  padding: 7px 14px;
  border-radius: 10px;
  background: #000000;
  border: 1px solid #000000;
  color: #ffffff;
  font-size: 12px;
  font-weight: 850;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  text-decoration: none;
  transition: all 0.2s ease;
}

.mtd-view-details-btn:hover {
  background: #111827;
  border-color: #111827;
  color: #ffffff;
  transform: translateY(-1px);
}

@media (max-width: 768px) {
  .payment-header-actions {
    justify-content: flex-start;
    width: 100%;
  }

  .mtd-view-details-btn {
    height: 32px;
    min-width: 100%;
  }
}

.payment-panel {
  flex: 1 1 auto !important;
  min-height: 0 !important;
}

.recent-payment-list {
  max-height: 400px !important; /* shows around 4 payment detail cards */
}

@media (max-width: 1399px) {
  .recent-payment-list {
    max-height: 410px !important;
  }
}

@media (max-width: 768px) {
  .recent-payment-list {
    max-height: 380px !important;
  }
}
</style>
